import React from 'react';
import PropTypes from 'prop-types';

import Card from "UI/Card";
import MediaCardSettingsMenu from "Components/MediaCard/MediaCardSettingsMenu";
import { getThumbnailUrl } from "Data/media/MediaSelectors";
import MediaDetailModal from "Components/MediaDetailModal";

export default class MediaCard extends React.Component
{
    state = {
        showDetailModal: false
    };

    static propTypes = {
        file: PropTypes.object.isRequired,
        removeMedia: PropTypes.func.isRequired,
    };

    showDetail = (e) => {
        e.preventDefault();

        this.setState({showDetailModal: true});
    };

    hideDetail = (e) => {
        e.preventDefault();

        this.setState({showDetailModal: false});
    };

    render()
    {
        const { file } = this.props;

        const url = getThumbnailUrl(file, 400, 600);

        const supportedThumbnailTypes = ['image/png', 'image/jpeg'];

        const thumbnail = supportedThumbnailTypes.some(type => file.type === type)
            ? <div className="bg-gray-100 rounded-t-lg bg-center bg-cover aspect-w-4 aspect-h-6" style={{backgroundImage: "url('" + url + "')"}} />
            : <div className="bg-gray-100 rounded-t-lg bg-center bg-cover aspect-w-4 aspect-h-6" />;

        return <Card tight className='group'>
            <a href='#' onClick={this.showDetail}>
                { thumbnail }
            </a>
            <div className='p-4 space-y-4'>
                <div className='flex items-center space-x-4'>
                    <div className='flex-grow truncate'>{file.label}</div>
                    <MediaCardSettingsMenu file={file} />
                </div>
                <div className='text-gray-400 text-sm flex-grow'>
                    {
                        formatBytes(file.size)
                    }
                </div>
            </div>
            <MediaDetailModal
                open={this.state.showDetailModal}
                onClose={this.hideDetail}
                media={file}
            />
        </Card>;
    }
}

function formatBytes(bytes, decimals = 0) {
    if (bytes === 0) return '0 Bytes';

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}
